export default {
    modulos: [],
    hasAnyAccess: true,
    moduloAtivo: localStorage.getItem('moduloAtivo') || null,
    carregandoModulos: false,
    trocandoModulo: false,

    // CRUD admin
    buscando: false,
    paginacao: null,
    items: [],
    selecionado: {},
    usuarios: []
}